/**
 * Scene load debugging — Step 2.5 dev tools.
 *
 * LOAD_ALL_UPFRONT
 *   When true, every mesh and idle clip loads in phase 1 (no phase-2 gate).
 *   DEV ONLY — never ship enabled. It regresses LCP (~8s back toward ~36s).
 *   Use it to test whether a bug is load-timing related: if the bug disappears
 *   with everything upfront, the root cause is in the load lifecycle.
 */
export const LOAD_ALL_UPFRONT = false

/**
 * Character-system debug switches — DEV ONLY, never ship enabled.
 * Toggle in sceneLoadConfig.js to isolate one layer at a time.
 */
/** Skip reveal visibility decisions; force both slot.root.visible = true always. */
export const FORCE_ALL_VISIBLE = false
/** Skip scan-in/out animation; snap to settled visibility immediately. */
export const SKIP_REVEAL_VFX = false
/** Skip idle-mode switching; characters stay in bind pose. */
export const FORCE_BIND_POSE = false
